import { render, staticRenderFns } from "./TestOptionTab.vue?vue&type=template&id=728f988a&scoped=true&"
import script from "./TestOptionTab.vue?vue&type=script&lang=js&"
export * from "./TestOptionTab.vue?vue&type=script&lang=js&"
import style0 from "./TestOptionTab.vue?vue&type=style&index=0&id=728f988a&lang=scss&scoped=true&"
import style1 from "./TestOptionTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f988a",
  null
  
)

export default component.exports